// extracted by mini-css-extract-plugin
export var navMobile = "layout-module--navMobile--7e469";
export var page = "layout-module--page--143b4";